document.querySelectorAll('button[data-action="toggle-collapsible"]').forEach(function(el) {
  el.addEventListener('click', function() {
    if (el.getAttribute('aria-expanded') !== 'true') {
      el.setAttribute('aria-expanded', 'true');
      el.nextElementSibling.style.height = '0px';
      el.nextElementSibling.style.height = el.nextElementSibling.scrollHeight + 'px';
      setTimeout(() => {
        el.nextElementSibling.style.height = 'auto';
      }, 300)
    } else {
      el.setAttribute('aria-expanded', 'false');
      el.nextElementSibling.style.height = el.nextElementSibling.scrollHeight + 'px';
      setTimeout(() => {
        el.nextElementSibling.style.height = '0px';
      }, 10)
    }
  });
});